import React, { useEffect, useState, useRef, useCallback } from 'react';
import PdfViewerComponent from './PdfViewerComponent';
import DummyPdf from './dummy.pdf';
import DummyJson from './dummy.json';
import { Worker } from '@react-pdf-viewer/core';
import NewGrid from '../NewGrid';
import { DASHBOARD, DATA_ENTRY, NEW_DATA_ENTRY, NEW_EDIT_WORK, NEW_QA_REVIEW } from '../../../../routeNames.js';
import { fetchAllJobDetails, fetchLogAllJobDetails, updateJobUserStartTime1, verificationJobUser1 } from '../../../../redux/newGrid/actions';
import CustomSweetAlert from '../components/common/CustomSweetAlert';
import { useGridCustomAlert } from '../hooks/useGridCustomAlert';
// import { changeAllTitleFunction } from '../../Dashboard/functions';
import { getErrorMessage, getTaskType } from '../utils';
// import { deleteIndexedData, getIndexedData, saveIndexedData } from '../../DataEntry/indexedDB';
import Swal from 'sweetalert2';
import { handleNavigateDashBoard } from '../utils/index1';
import SweetAlert from 'react-bootstrap-sweetalert';
import { exitGrid } from '../../../../redux/grid/action';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Toast, ToastContainer } from 'react-bootstrap';

const PdfViewer = () => {
    const user = JSON.parse(localStorage.getItem("user"));
    const user_idle_time_out = user?.settings?.filter((i) => i?.key_name === 'ideal_user_timeOut')[0]?.value

    const location = useLocation();
    const navigate = useNavigate();
    const queryParams = new URLSearchParams(location.search);
    const log_id = queryParams.get('log_id');
    const currentJog_id = queryParams.get('job_id');

    let { job_id } = useParams();

  const fullDataRef = useRef(null);
  const jobQueueRef = useRef([]);
  const pdfCacheRef = useRef(new Map());
  const isPreloadingRef = useRef(false);
  const isSaveCurrentJobApi = useRef(true)

  const { alert, showAlert, hideAlert } = useGridCustomAlert();
  const [isViewOnllyGrid, setIsViewOnllyGrid] = useState(false);
  
  const [gridFormLoader, setGridFormLoader] = useState(false);
  const [fileUrl, setFileUrl] = useState(null);
  const [noJob, setNoJOb] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [numPages, setNumPages] = useState(null);
  const [loader, setLoader] = useState(true);
  const [isViewAllPage, setIsViewAllPage] = useState(false);
  const [isLoadDataTrue, setIsLoadDataTrue] = useState(false)
  const [viewPage, setViewPage] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [preloadingStatus, setPreloadingStatus] = useState('');
  const [facilitySwal, setFacilitySwal] = useState({
          id:null,
          isSwal:false,
      });
   const [gotoPageNumber, setGotoPageNumber] = useState(null);
   const isLoadFromCacheRef = useRef(false)
  const [toast, setToast] = useState({
    status: false,
    type: "",
    message: ""
  });


  const handleDocumentLoad = (totalPageCount) => {
    setTotalPages(totalPageCount);
  };
const handlePermissionJob = async() => {
    if(alert.data?.is_errorJob){
        // await saveIndexedData('error_data', alert?.data?.data);
    }
    navigate('.', { replace: true });
    window.location.reload()
}
  // Function to download and cache PDF
  const downloadAndCachePdf = useCallback(async (pdfUrl, jobId) => {
    if (!pdfUrl || pdfCacheRef.current.has(jobId)) {
      return pdfCacheRef.current.get(jobId) || pdfUrl;
    }

    try {
      const response = await fetch(pdfUrl);
      if (response.ok) {
        const blob = await response.blob();
        const cachedUrl = URL.createObjectURL(blob);
        pdfCacheRef.current.set(jobId, cachedUrl);
        return cachedUrl;
      }
    } catch (error) {
      console.error('Failed to cache PDF:', error);
    }
    
    return pdfUrl;
  }, []);

  // Function to preload next job
  const preloadNextJob = useCallback(async () => {
    if (isPreloadingRef.current) return;
    
    isPreloadingRef.current = true;
    setPreloadingStatus('Loading next job...');

    try {
      const nextJobResult = await fetchAllJobDetails({
        work_type: getTaskType(),
        work_queue: true
      });

      if (!nextJobResult?.error && nextJobResult?.job) {
        // Add to queue if not already present
        const existingJobIndex = jobQueueRef.current.findIndex(
          job => job.job === nextJobResult?.job
        );
        
        if (existingJobIndex === -1) {
          jobQueueRef.current.push(nextJobResult);

           
          
          // Preload PDF for next job
          if (nextJobResult.file_url) {
            setPreloadingStatus('Downloading next PDF...');
            await downloadAndCachePdf(nextJobResult.file_url, nextJobResult?.job);
          }
        }
      }
    } catch (error) {
      console.error('Failed to preload next job:', error);
    } finally {
      isPreloadingRef.current = false;
      setPreloadingStatus('');
    }
  }, [downloadAndCachePdf ,facilitySwal]);

const checkUserPermissions = useCallback(async () => {

  let pathname =  window.location.pathname
  const isQaScreen = pathname === NEW_QA_REVIEW
  const isMyworkScreen = pathname === NEW_DATA_ENTRY
  const task_type = isMyworkScreen ? 1 : isQaScreen ? 2 : 1
  
  if(!fullDataRef?.current)return
  try {
    const jobData = fullDataRef?.current
    const hasPermission = await verificationJobUser1(task_type, jobData?.job);
    
    if (hasPermission?.data === false) {
      
      showAlert('noPermission', '', 'You have no permission on the recently loaded job');
      return false;

    } else {
            await updateJobUserStartTime1(task_type, jobData?.job);
            const preloadPromise = preloadNextJob();
            await preloadPromise;
            isSaveCurrentJobApi.current = true
            return true;
    }

    } catch (error) {
        console.error("Permission check failed:", error);
        return false;
    }
}, [preloadNextJob,fullDataRef]);


  // Enhanced submit function
  const loadNextJob = useCallback(async () => {
    if (isSubmitting) return;
    
    setIsSubmitting(true);
    setLoader(true);

    try {


        // Load next job from queue or fetch new one
        let nextJob = null;
        
        if (jobQueueRef.current.length > 0) {
            nextJob = jobQueueRef.current.shift();
        } else {
             setNoJOb(true)
             fullDataRef.current = null;
        }

        if (nextJob) {
            if(!nextJob?.status&&nextJob?.errors==="No job remaining"){
                setNoJOb(true)
                return;
            }
            // Update current job data
            fullDataRef.current = { ...nextJob };
            
            // Set cached PDF URL or original URL
            const cachedPdfUrl = pdfCacheRef.current.get(nextJob.job) || nextJob.file_url;
            setFileUrl(cachedPdfUrl);
            
            // Reset page states
            setCurrentPage(1);
            setTotalPages(0);
            setNumPages(null);
            
            // Show comment alert if needed
            if (nextJob?.is_large_batch_job || nextJob?.file_info?.comment) {
                showAlert('comment');
            }

          setFacilitySwal(prev=>({
            id:nextJob?.facility_id,
            isSwal: nextJob?.facility_id && prev?.id ? nextJob.facility_id === prev.id ? false : true : false
          }))
          

            // // Start preloading the next job after this one
            // setTimeout(() => preloadNextJob(), 1000);
        } else {
            setNoJOb(true);
        }

      
    } catch (error) {
      console.error('Submit form error:', error);
      showAlert('submit_error');
    } finally {
      setIsSubmitting(false);
      setLoader(false);
    }
  }, [isSubmitting, checkUserPermissions, preloadNextJob, showAlert,pdfCacheRef,jobQueueRef]);

  // Initial API fetch
const fetchInitialApis = async () => {
    const work_type = getTaskType()
    try {
        const result = await fetchAllJobDetails({
            work_type,
            work_queue: false,
            job:currentJog_id
        });
        
        if (!result?.status && result?.errors === "No job remaining") {
            setNoJOb(true);
            return; // Exit early
        }
        else if (result?.status === false) {
            const title = getErrorMessage(result?.errors) || 'Something Went Wrong'
            const message = result?.message?result?.message:null
            showAlert('general',title,message,null,handleNavigateDashBoard,null);
            return; // Exit early
        }
        
        const error_data = {}
        const grid_data_cache = {}
        let currentJobData = result;
        // Cache the initial PDF
        const cachedUrl = await downloadAndCachePdf(result?.file_url, result?.job);
        setFileUrl(cachedUrl);
        
        if (Object.keys(error_data?.data || {}).length > 0) {
            currentJobData = { ...result, grid_data: error_data?.data };
            // await deleteIndexedData('error_data');
        } else if (grid_data_cache?.data?.job===result?.job && Object.keys(grid_data_cache?.data || {}).length > 0) {
            // Wait for user's decision on the Swal dialog
            const swalResult = await Swal.fire({
                icon: 'success',
                confirmButtonColor: '#6ba2b6',
                confirmButtonText: 'CACHE',
                cancelButtonText: 'CANCEL',
                showConfirmButton: true,
                showCancelButton: true,
                denyButtonColor: '#6ba2b6',
                allowOutsideClick: false,
                backdrop: true,
                title: `LOAD SAVED DATA FROM?`,
                customClass: {
                    title: 'swal-titleText fs-5'
                }
            });
            
            if (swalResult?.isConfirmed) {
                currentJobData = { ...result, grid_data: grid_data_cache?.data };
                const visited_pages = {}
                setViewPage(visited_pages?.data)
                isLoadFromCacheRef.current = localStorage.getItem('837_pulled') || false

            }else if(swalResult?.isDismissed){
                // Delete cache data regardless of user choice
                // deleteIndexedData('grid_data_cache');
            }
        }

        // This code now runs after the Swal dialog is resolved
        fullDataRef.current = { ...currentJobData };
        
        if (result?.is_large_batch_job || result?.file_info?.comment) {
            showAlert('comment');
        }

      
        setFacilitySwal({
            id:result?.facility_id,
            isSwal: result?.facility_id && facilitySwal?.id ? result.facility_id === facilitySwal.id ? false : true : false
          })  
     
          

        // Start preloading next job
        setTimeout(() => preloadNextJob(), 2000);
        
    } catch (error) {
        console.error('Initial fetch error:', error);
        showAlert('error');
    }
};
const fetchLogInitialApis = async (job_log,log_id) => {
    const result = await fetchLogAllJobDetails(job_log,log_id);
    if (result?.status === false) {
            const title = getErrorMessage(result?.errors) || 'Something Went Wrong'
            const message = result?.message?result?.message:null
            showAlert('general',title,message,null,handleNavigateDashBoard,null);
            return; // Exit early
    }else{
        // Cache the initial PDF
        const cachedUrl = await downloadAndCachePdf(result?.file_url, result?.job);
        setFileUrl(cachedUrl);
        fullDataRef.current = { ...result };
    }

};

  // Cleanup function for cached URLs
  const cleanupCache = useCallback(() => {
    pdfCacheRef.current.forEach((url, jobId) => {
      if (url.startsWith('blob:')) {
        URL.revokeObjectURL(url);
      }
    });
    pdfCacheRef.current.clear();
  }, []);

  useEffect(() => {
    const isLogScreen = true
    if(isLogScreen){
        fetchLogInitialApis(job_id,log_id)
        setIsViewOnllyGrid(true)
    }else{
        fetchInitialApis();
    }
    // Cleanup on unmount
    return () => {
      cleanupCache();
    };
  }, [job_id,log_id]);

 const resetViewPage = (totalPages, truePosition) => {

        if (truePosition < 0 || truePosition > totalPages || window.location.pathname == NEW_QA_REVIEW) {
            console.warn('The position provided is out of the valid range.')
            return;
        }
        const viewPageState = Array(totalPages).fill(false)
        viewPageState[truePosition-1] = true
        setViewPage(viewPageState)
        setGotoPageNumber(truePosition)
    };
    useEffect(() => {
        if (window.location.pathname ==   NEW_QA_REVIEW) {
            setIsViewAllPage(true)
        } else if (!isLoadDataTrue) {
            setViewPage(Array(totalPages).fill(false));
        }
        setIsLoadDataTrue(false)

    }, [totalPages])
 useEffect(() => {
        let timer;
        if (currentPage !== '' && totalPages > 0 && (window.location.pathname !== NEW_QA_REVIEW)) {
            timer = setTimeout(() => {
                setViewPage(prevViewPage => {
                    const updatedViewPage = [...prevViewPage];
                    updatedViewPage[currentPage-1] = true;
                    return updatedViewPage;
                });


            }, 300);
            // saveIndexedData('visited_pages', viewPage);

        }
        return () => clearTimeout(timer);
    }, [currentPage, totalPages]);

    useEffect(() => {
            if (totalPages > 0) {
                setIsViewAllPage(!viewPage?.some(element => element === false))
    
            }
        }, [viewPage])

  const [isExitGrid, setIsExitGrid] = useState(false)
    //////////////////////////////////// grid idle timeout start///////////////////////////////////
useEffect(() => {
    if (window.location.pathname !== NEW_EDIT_WORK + job_id && user?.is_ideal_timeout) {
        let alive = false
        let minute = 1;
        let gridExited = false;
        let timeout = setInterval(() => {
            if (alive) {
                alive = false
                minute = 1
            }
            else {
                minute = minute + 1
                if (minute > user_idle_time_out && !isExitGrid && !gridExited) {
                    const task_type = getTaskType()
                    exitGrid(fullDataRef?.current?.job, task_type, true)((response) => {
                        if (response?.status && response?.status_code == 200) {
                            setIsExitGrid(true)
                            gridExited = true;
                            showAlert('general',null,"Idle Timeout",null,handleNavigateDashBoard,null);
                        }
                    })
                }
            }
        }, 60000);
        const resetTimer = () => {
            if (!alive) {
                alive = true
            }
        };
        window.addEventListener('mousemove', resetTimer);
        window.addEventListener('keydown', resetTimer);
        window.addEventListener('click', resetTimer);
        window.addEventListener('scroll', resetTimer);

        return () => {
            clearInterval(timeout);
            window.removeEventListener('mousemove', resetTimer);
            window.removeEventListener('keydown', resetTimer);
            window.removeEventListener('click', resetTimer);
            window.removeEventListener('scroll', resetTimer);
        };
    }
}, [fullDataRef?.current])


  return (
    <>
      {/* <Header gridFormLoader={gridFormLoader} job={fullDataRef.current} /> */}

      {facilitySwal?.isSwal == true && 
      <SweetAlert
        warning
        confirmBtnText="Ok!"
        confirmBtnCssClass="custom-confirm-button-class"
        title={"Partner or Client or Facility Changed"}
        onConfirm={() => { setFacilitySwal({ ...facilitySwal, isSwal: false }) }}

      >

      </SweetAlert>
      }
      
      {/* Preloading status indicator */}
      {preloadingStatus && (
        <div className="position-fixed top-0 end-0 m-3 z-index-1050">
          <div className="badge badge-primary">
            {preloadingStatus}
          </div>
        </div>
      )}
    {/* Single Alert Component */}
        <CustomSweetAlert
        alert={alert}
        hideAlert={hideAlert}
        // Business logic props
        jobData={fullDataRef.current}
        notification={null}
        setingPayer={() => {}}
        setPayerPullPath={() => {}}
        handleNavigateDashBoard={handleNavigateDashBoard}
        handlePermissionJob={handlePermissionJob}
        loadNextJob={loadNextJob}
        />

        {
                toast &&
                <React.Fragment>
                    <ToastContainer containerPosition="position-fixed" position="top-end" className="p-3">
                        <Toast bg={toast.type} onClose={() => setToast(!toast.status)} show={toast.status} delay={2000} autohide>

                            <Toast.Body><span className='text-white fw-bold'>{toast.message}</span></Toast.Body>
                        </Toast>
                    </ToastContainer>
                </React.Fragment>
            }
      {noJob ? (
        <React.Fragment>
          <div className='d-flex flex-column justify-content-center align-items-center height-100'>
            <span className='text-primary badge badge-light-primary fs-1'>
              NO PENDING JOBS
            </span>
            <button
              onClick={() =>{
                  navigate('.', { replace: true });
                  window.location.reload();
              }}
              className='btn btn-light btn-lg rounded-1 mt-3 btn-active-primary'
            >
              Refresh
            </button>
          </div>
        </React.Fragment>
      ) : (
        <>
          {!!(totalPages && fullDataRef.current) && (
            <>              
              <NewGrid
                setGridFormLoader={setGridFormLoader}
                jobData={fullDataRef.current}
                totalPDFPages={totalPages}
                currentPdfPage={currentPage}
                jumpToPage={(page) => setGotoPageNumber(page)}
                showAlert={showAlert}
                loadNextJob={loadNextJob} // Pass the enhanced submit function
                checkUserPermissions={checkUserPermissions}
                isSubmitting={isSubmitting}
                resetViewPage={resetViewPage}
                setViewPage={setViewPage}
                isViewAllPage={isViewAllPage}
                job_log={job_id}
                log_id={log_id}
                isViewOnllyGrid={isViewOnllyGrid}
                isLoadFromCacheRef={isLoadFromCacheRef}
                setToast={setToast}
                isSaveCurrentJobApi={isSaveCurrentJobApi}

              />
            </>
          )}
          
          <Worker workerUrl="/assets/js/pdf.worker.min.js">
            <div
              id="magnifier-box"
              style={{
                border: '1px solid rgba(0, 0, 0, 0.3)',
                height: '96.6vh',
                maxHeight: '96.6vh',
              }}
            >
              <div className='first-pdf active-pdf'>
                <PdfViewerComponent
                    key={`${fullDataRef.current?.job}-${fileUrl}`} // This forces re-render when URL changes
                    loader={loader}
                    setLoader={setLoader}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                    numPages={numPages}
                    setNumPages={setNumPages}
                    jumpToPage={(page) => setCurrentPage(page)}
                    gotoPageNumber={gotoPageNumber}
                    fileUrl={fileUrl}
                    handleDocumentLoad={handleDocumentLoad}
                    isunvisitedPage={window.location.pathname === NEW_DATA_ENTRY}
                    viewPage={viewPage}
                    jobData={fullDataRef?.current}
                />
              </div>
            </div>
          </Worker>
        </>
      )}
    </>
  );
};

export default React.memo(PdfViewer);